// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var ViewStack = require("../../../reason/common/ViewStack.bs.js");
var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Text__Jsx3 = require("../../../uikit/reason/helpers/Text__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var AvatarSrcUrl = require("../../../utils/AvatarSrcUrl.bs.js");
var AgentInfo__Jsx3 = require("../../../uikit/reason/atoms/AgentInfo/AgentInfo__Jsx3.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Theme__Color__Vars = require("../../../reason/common/Theme/Theme__Color__Vars.bs.js");
var Colors = require("uikit/styles/colors");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var BuyerPageMatchCardOwnAnonymousAgent_agent_graphql = require("../../../__generated__/BuyerPageMatchCardOwnAnonymousAgent_agent_graphql.bs.js");

var convertFragment = BuyerPageMatchCardOwnAnonymousAgent_agent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, BuyerPageMatchCardOwnAnonymousAgent_agent_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(BuyerPageMatchCardOwnAnonymousAgent_agent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, BuyerPageMatchCardOwnAnonymousAgent_agent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(BuyerPageMatchCardOwnAnonymousAgent_agent_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function BuyerPageMatchCardOwnAnonymousAgent(props) {
  var __size = props.size;
  var size = __size !== undefined ? __size : "xSmall";
  var agent = use(props.agent);
  var match = agent.profilePhoto;
  var avatar = match !== undefined ? match.url : AvatarSrcUrl.place_holder;
  return JsxRuntime.jsx(AgentInfo__Jsx3.make, {
              avatar: avatar,
              size: size,
              name: agent.displayName,
              brokerage: agent.brokerage,
              wrapName: (function (name) {
                  return JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(ButtonsV5.Link.make, {
                                      href: "/agents/" + agent.id,
                                      onClick: (function (e) {
                                          e.stopPropagation();
                                        }),
                                      children: Caml_option.some(JsxRuntime.jsx("div", {
                                                children: name,
                                                className: "font-medium"
                                              }))
                                    }),
                                JsxRuntime.jsx(Text__Jsx3.make, {
                                      as_: "div",
                                      fontSize: {
                                        NAME: "px",
                                        VAL: 14
                                      },
                                      fontWeight: {
                                        NAME: "n",
                                        VAL: 400
                                      },
                                      color: Colors.gray,
                                      children: JsxRuntime.jsxs(ViewStack.make, {
                                            space: "zero",
                                            alignItems: "center",
                                            flexDirection: "row",
                                            children: [
                                              JsxRuntime.jsx("span", {
                                                    children: "("
                                                  }),
                                              JsxRuntime.jsxs(ViewStack.make, {
                                                    space: {
                                                      NAME: "px",
                                                      VAL: 5
                                                    },
                                                    flexDirection: "row",
                                                    children: [
                                                      JsxRuntime.jsx(Icon__Jsx3.make, {
                                                            icon: "Lock",
                                                            size: 12,
                                                            color: Theme__Color__Vars.gray
                                                          }),
                                                      JsxRuntime.jsx("div", {
                                                            children: "Only visible to you"
                                                          })
                                                    ]
                                                  }),
                                              JsxRuntime.jsx("span", {
                                                    children: ")"
                                                  })
                                            ]
                                          })
                                    })
                              ],
                              className: "flex flex-wrap gap-2"
                            });
                }),
              children: Caml_option.some(null)
            });
}

var make = BuyerPageMatchCardOwnAnonymousAgent;

exports.Fragment = Fragment;
exports.make = make;
/* ButtonsV5 Not a pure module */
